import cn from 'clsx'
import React, { useState } from 'react'
import Dropdown from 'components/ui/dropdowns/native-dropdown'
const orderOptions = [
  {
    value: 'PlaylistOrder',
    label: 'Use playlist order',
  },
  {
    value: 'ExistingOrder',
    label: 'Keep existing track order metadata',
  },
  {
    value: 'Reset',
    label: 'Remove track order metadata',
  },
]
type AliasTrackOrderFieldProps = {
  value: 'PlaylistOrder' | 'ExistingOrder' | 'Reset'
  onChange: (e: React.SyntheticEvent) => void
}
export const AliasTrackOrderField = (
  props: AliasTrackOrderFieldProps,
): React.ReactNode => {
  const [isFocused, setIsFocused] = useState(false)
  return (
    <Dropdown
      className={cn('EditMetaData_TrackOrder_Dropdown', {
        Focused: isFocused,
      })}
      selectClassName="EditMetaData_TrackOrder_Dropdown--options"
      options={orderOptions}
      value={props.value}
      onChange={props.onChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  )
}
export default AliasTrackOrderField
